import React, { useState } from 'react'
import {
    AccordionAccordion, Accordion, ListItem,
    Divider,
    Dropdown,
    List,
} from 'semantic-ui-react'



const countOptions = []
for (let i = 0; i <= 10; i++) {
    countOptions.push({ key: i, text: i, value: i })
}

const SelectExample = (prop) => {
    const [sel, setSel] = useState(prop.val);
    const handleChange = (e, { value }) => {

      var constdata = "?day="+ prop.day+"&hour="+ prop.hour+"&table="+ prop.table+"&newval="+ value
        var xhr = new XMLHttpRequest();

        xhr.open("GET", "https://ui.usdtpoker.club/setJsonBot"+constdata, true);
      


        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    setSel(value);
                    console.log(value, prop)

                } else {
                    console.error(xhr.statusText);
                }
            }
        };
        xhr.onerror = function (e) {
            console.error(e);
        };
        xhr.send(null)

    };

    return (
        <Dropdown placeholder='Select' defaultValue={sel} options={countOptions} onChange={handleChange} />
    )
}




const AccordionExampleNested = ({ day,jsonData }) => {
    const ListExampleSelection = (prop) => {

        return (
            <>
                {Object.keys(jsonData.Hours[day][prop.hour]).map(function (table, j) {
                    return (
                        <List verticalAlign='middle'>
                            <ListItem>
                                <span style={{ float: 'right' }}><SelectExample day={day} hour={prop.hour} table={table} val={jsonData.Hours[day][prop.hour][table].min} /></span>
                                {table}
                                <Divider />
                            </ListItem>

                        </List>
                    )
                })
                } </>)
    }
    const level1Panels = []
    Object.keys(jsonData.Hours[day]).map(function (key, j) {
        level1Panels.push({ key: 'panel-' + j, title: key, content: { content: <ListExampleSelection hour={key} /> } })
    })

    const Level1Content = <AccordionAccordion panels={level1Panels} defaultActiveIndex={-1} />



    const rootPanels = [
        { key: 'panel-1', title: day, content: { content: Level1Content } },
    ]
    return (
        <Accordion defaultActiveIndex={-1} panels={rootPanels} styled day={day} fluid />
    )
}

export default AccordionExampleNested